export const LOCAL = 'local';
export const DEV = 'dev';
export const STAGE = 'stg';
export const PROD = 'prod';
